import axios, { AxiosRequestConfig } from 'axios';
import {Config} from "../config/config";
import {activeUser} from "./AuthService";

export const axiosDefaults: AxiosRequestConfig = {
    baseURL: Config.apiRoot,
    withCredentials: true,
};

export const axiosInstance = axios.create(axiosDefaults);
axiosInstance.interceptors.request.use((request) => {
    if (activeUser && activeUser.accessToken) {
        console.log("axios")
        //console.log(JSON.stringify(activeUser))
        // @ts-ignore
        request.headers.Authorization = 'Bearer ' + activeUser.accessToken;
    }
    return request;
});

axiosInstance.interceptors.response.use((response) => response, (error) => {
    // whatever you want to do with the error
    if (error.response.status == 401) {
        window.location.href = '/login';
    }
    throw error;
});

